import type { SupportingTextProps, TextProps, TextsWrapperProps } from './TextsWrapper.types'
import cn from 'classnames'
import * as React from 'react'
import { sanitizeHTML } from '../../../utils'
import { Typography } from '../../typography'
import { BannerContext } from '../BannerContext'
import styles from './TextsWrapper.module.css'

export function TextsWrapper({ children, className }: TextsWrapperProps) {
  return (
    <div className={cn(styles.textsWrapper, className)}>
      {children}
    </div>
  )
}

export function Text({ children, className, size }: TextProps) {
  const { size: bannerSize } = React.use(BannerContext)
  const componentSize = size ?? bannerSize
  return (
    <strong className={cn(styles.text, { [styles.textSizeS]: componentSize === 'S' }, className)}>
      {children}
    </strong>
  )
}

export function SupportingText({ children, innerHTML, className, size }: SupportingTextProps) {
  const { size: bannerSize } = React.use(BannerContext)
  const componentSize = size ?? bannerSize
  const cls = cn(styles.supportingText, { [styles.supportingTextSizeS]: componentSize === 'S' }, className)

  if (innerHTML) {
    return (
      <Typography
        as="div"
        className={cls}
        dangerouslySetInnerHTML={{ __html: sanitizeHTML(innerHTML) }}
      />
    )
  }

  return (
    <Typography className={cls}>
      {children}
    </Typography>
  )
}
